import type { AudienceSegment } from './types';

/** Traduce el segmento de la pantalla al que entiende el servidor.
 *
 *  VIVE EN UN SOLO LUGAR A PROPÓSITO. Esta función estaba dentro del paso 3, y
 *  le faltaba el caso de `active_term_students`: caía al `default` y la campaña
 *  se mandaba a TODA la base de contactos en vez de a los alumnos del período.
 *  Un `switch` incompleto escondido dentro de un componente no lo mira nadie.
 *
 *  Ahora la usan el envío Y el conteo previo, que es lo que garantiza que el
 *  número que se confirma sea el de la audiencia que va a recibir.
 */
export function segmentPayload(seg: AudienceSegment): Record<string, unknown> {
  switch (seg.type) {
    case 'tag':
      return { type: 'tag', tag: seg.tag! };
    case 'by_person_type':
      return { type: 'by_person_type', personTypes: seg.personTypes! };
    case 'by_institutional_role':
      return { type: 'by_institutional_role', roles: seg.roles! };
    case 'by_program':
      return { type: 'by_program', programId: seg.programId! };
    case 'by_course':
      return {
        type: 'by_course',
        courseId: seg.courseId!,
        ...(seg.termId ? { termId: seg.termId } : {}),
      };
    case 'custom_contacts':
      return { type: 'custom_contacts', contactIds: seg.contactIds! };
    case 'active_term_students':
      // FALTABA ESTE CASO, y su ausencia no era inofensiva: caía al `default` y
      // la campaña se mandaba a TODA la base de contactos en vez de a los
      // alumnos del período. El servidor sí soporta el segmento.
      return {
        type: 'active_term_students',
        missingEnrollment: seg.missingEnrollment === true,
        missingPaymentPlan: seg.missingPaymentPlan === true,
      };
    default:
      return { type: 'all_crm' };
  }
}
